import React, { useState, useEffect } from 'react';
import { useDispatch } from "react-redux";
import DataGrid, {
    Column,
    FilterRow,
    ColumnChooser,
    Paging,
    Selection,
    Scrolling,
    Export,
    GroupPanel,
    Grouping,
    Format,
    Pager,
    Summary,
    GroupItem,
    SortByGroupSummaryInfo,
    RequiredRule,
    Label,
    Editing,
    Lookup,
    Popup,
    Form as GridForm
} from 'devextreme-react/data-grid';
import Request from "../../components/Request/Request";
import { Button } from 'devextreme-react/button';
import 'devextreme/data/odata/store';
import './KullaniciHesap.scss';
import CustomStore from 'devextreme/data/custom_store';

import TextBox from 'devextreme-react/text-box';
import FileUploader from 'devextreme-react/file-uploader';
import * as AppActions from '../../actions/AppActions';
import { DateBox, Form, SelectBox, Popup as PopupForm, CheckBox } from 'devextreme-react';
import { Item, Tab, TabbedItem, TabPanelOptions } from 'devextreme-react/form';
import { showToast } from '../../utils/Utils';
import { ToastType } from '../../constants/Constants';
import HesapForm from '../hesap/HesapForm';
import HesapDetayDuzenleForm from './HesapDetayDuzenleForm';
import { custom } from 'devextreme/ui/dialog';

const KullaniciHesap = (props) => {

    const dispatch = useDispatch();

    const listeBasligi = "Hizmet Form ";
    const [store, setStore] = useState({});

    const [detayDataPopup, setDetayDataPopup] = useState({ popupState: false, data: {} });
    const [hesapDuzenleDataPopup, setHesapDuzenleDataPopup] = useState({ popupState: false, data: {} });

    const [hesaplaDetayDtoList, setHesaplaDetayDtoList] = useState([]);
    const [sonucDtoList, setSonucDtoList] = useState([]);

    const [storeHesapTuru, setStoreHesapTuru] = useState([
        { id: 'YASLILIK', name: 'Yaşlılık' },
        { id: 'MALULLUK', name: 'Malüllük' },
        { id: 'OLUM', name: 'Ölüm' },
        { id: 'VERGI_INDIRIMI', name: 'Vergi İnd' }
    ]);
    const [storeBakmaklaYukumluOlduguEsCocuk, setStoreBakmaklaYukumluOlduguEsCocuk] = useState([
        { id: 'YOK', name: 'Yok' },
        { id: 'VAR', name: 'Var' }
    ]);

    const [storeHesaplaDetayTuru, setStoreHesaplaDetayTuru] = useState([]);

    useEffect(() => {
        setHesaplaDetayTuruList();
    }, [])

    function setHesaplaDetayDtoDataList() {
        let data = store;

        if (!data.tcKimlikNo || data.tcKimlikNo.length == 0) {
            return;
        }



        const request = new Request("/emeklilik-app/api/personel-ek-hesap-bilgi/getListByTcKimlikNo/" + data.tcKimlikNo, "GET");
        request.run()
            .then(response => {
                if (response.data && response.data.data) {
                    setHesaplaDetayDtoList(response.data.data);
                }
            });

    }

    function setHesaplaDetayTuruList() {
        if (!storeHesaplaDetayTuru || storeHesaplaDetayTuru.length == 0) {
            const request = new Request("/emeklilik-app/api/enum-tanim/getList/HesaplaDetayTuru", "GET");
            request.run()
                .then(response => {
                    if (response.data && response.data.data) {
                        setStoreHesaplaDetayTuru(response.data.data);
                    }
                });
        }
    }

    function hesapla() {

        let data = store;
        data.hesaplaDetayDtoList = hesaplaDetayDtoList;

        if (!data.tcKimlikNo || data.tcKimlikNo.length == 0) {
            showToast("TcKimlik bilgisini giriniz", ToastType.ERROR, 500)
            return;
        }

        setHesaplaDetayDtoDataList();
        dispatch(AppActions.setLoading(true, "Kayıt yükleniyor.."));
        const request = new Request("/emeklilik-app/api/kullanici-hesap/kullaniciDetayEkleHesapla", "POST", data);
        return request.run()
            .then(response => {
                if (response.data && response.data.data) {
                    setSonucDtoList(response.data.data);
                } else {
                    setSonucDtoList([]);
                }
                dispatch(AppActions.setLoading(false, ""));
            });


    }

    function goruntule(data) {
        dispatch(AppActions.setLoading(true, "Kayıt yükleniyor.."));
        const request = new Request("/emeklilik-app/api/kullanici-hesap/getHesapDto", "POST", data);
        return request.run()
            .then(response => {
                if (response.data && response.data.data) {
                    setDetayDataPopup({ popupState: true, data: response.data.data })
                }
                dispatch(AppActions.setLoading(false, ""));
            });
    }
    function hideDetayDataPopup() {
        setDetayDataPopup({ popupState: false, data: {} })
    }

    function hideHesapDuzenleDataPopup() {
        setHesapDuzenleDataPopup({ popupState: false, data: {} });
        setHesaplaDetayDtoDataList();
    }

    function onToolbarPreparingHesapDetay(e) {
        e.toolbarOptions.items.unshift({
            location: 'before',
            //template: 'totalGroupCount'
        }, {
            location: 'after',
            widget: 'dxButton',
            visible: () => { return true },
            options: {
                icon: 'add',
                onClick: () => {
                    setHesapDuzenleDataPopup({ popupState: true, data: { tcKimlikNo: store.tcKimlikNo } })
                }
            }
        });
    }

    function editHesapDetay(data) {
        setHesapDuzenleDataPopup({ popupState: true, data: data })
    }
    function deleteHesapDetay(data) {
        let myDialog = custom({
            title: "Silme Uyarı",
            messageHtml: "<b>Seçili kaydı silmek istiyor musunuz?</b>",
            buttons: [{
                text: "Evet",
                onClick: (e) => {
                    return { buttonText: e.component.option("text") }
                }
            }, {
                text: "Hayır",
                onClick: (e) => {
                    return { buttonText: e.component.option("text") }
                }
            },
            ]
        });
        myDialog.show().then((dialogResult) => {
            if (dialogResult.buttonText === 'Evet') {
                dispatch(AppActions.setLoading(true, "Kayıtlar siliniyor.."));
                const request = new Request("/emeklilik-app/api/personel-ek-hesap-bilgi/delete/" + data.id, "DELETE");
                request.run()
                    .then(response => {
                        dispatch(AppActions.setLoading(false, ""));
                        if (response.statusText == 'OK') {
                            setHesaplaDetayDtoDataList();
                        }
                    });
            }

        });



    }

    function editSecimeHesapDetayRender(e) {
 
        let data = e.row.data;
        if(data.secili){
            return <Button icon="check"    onClick={(e) => { editSecimeHesapDetay(data); }} />;            

        }else{
            return <Button icon="isblank"    onClick={(e) => { editSecimeHesapDetay(data); }} />;
        } 
    }

    function editSecimeHesapDetay(data) {
       

        data.secili = !data.secili;
        const request = new Request("/emeklilik-app/api/personel-ek-hesap-bilgi/save", "POST", data);
        request.run()
            .then(response => {

                if (response.statusText == 'OK') {
                    setHesaplaDetayDtoDataList();
                }
            });
    }
    return (
        <div >
            <Form formData={store} colCount={1} id="form" labelLocation={"left"} className="option" >
                <TabbedItem  >
                    <TabPanelOptions deferRendering={false} />
                    <Tab title="Genel Bilgileri">
                        <Item itemType="group" colCount={5} colSpan={5}>
                            <Item itemType="group" caption={"Hesap Değişkenleri"} colCount={1} colSpan={1}>
                                <Item dataField={'tcKimlikNo'} editorType={'dxTextBox'}
                                    editorOptions={{
                                        stylingMode: 'outlined',
                                        readOnly: false
                                    }}>
                                    <RequiredRule message="TcKimlik bilgisi gerekli" />
                                    <Label text='TcKimlik' />
                                </Item>
                                <Item dataField={'hesapTarihi'} editorType={'dxDateBox'}
                                    editorOptions={{
                                        stylingMode: 'outlined',
                                        readOnly: false,
                                        //type: "date", 
                                        //displayFormat: "dd.MM.yyyy",
                                        pickerType: "rollers"
                                    }}>
                                    <RequiredRule message="Hesap Tarihi bilgisi gerekli" />
                                    <Label text='Hesap Tarihi' />
                                </Item>
                                <Item disabled={false} dataField={'hesapTuru'} editorType={'dxSelectBox'}
                                    editorOptions={{
                                        dataSource: storeHesapTuru,
                                        valueExpr: "id",
                                        displayExpr: "name",
                                        placeholder: "Select a value...",
                                    }}>
                                    <RequiredRule message="Hesap Türü bilgisi gerekli" />
                                    <Label text='Hesap Türü' />
                                </Item>

                                <Item disabled={false} dataField={'raporOrani'} editorType={'dxNumberBox'}
                                    editorOptions={{
                                        min: 0,
                                        max: 100
                                    }}>
                                    <Label text='Rapor Oranı ' />
                                </Item>

                                <Item disabled={false} dataField={'bakmaklaYukumluOlduguEsCocuk'} editorType={'dxSelectBox'}
                                    editorOptions={{
                                        dataSource: storeBakmaklaYukumluOlduguEsCocuk,
                                        valueExpr: "id",
                                        displayExpr: "name",
                                        placeholder: "Select a value...",
                                    }}>
                                    <RequiredRule message="Bakmakla Yükümlü Olduğu Eş Çocuk bilgisi gerekli" />
                                    <Label text='BYO Eş-Ç ' />
                                </Item>

                                <Item disabled={false} dataField={'avantajliOlanlariGetir'} editorType={'dxCheckBox'}
                                    editorOptions={{
                                        defaultValue: false
                                    }}>
                                    <Label text='Avantajlı Olanlar' />
                                </Item>

                                <Item dataField={'maasAralik'} editorType={'dxNumberBox'}
                                    editorOptions={{ format: "#,##0", showClearButton: true }}>
                                    <Label text='Hesap Aralık' />
                                </Item>

                                <Item>
                                    <Button icon="find" width={150} text="Hesapla" type={'success'} style={{ fontSize: "15px" }} onClick={hesapla}></Button>
                                </Item>

                            </Item>

                            <Item itemType="group" caption={"Hesap ek bilgileri"} colCount={4} colSpan={4}>
                                <DataGrid
                                    width="100%"
                                    dataSource={hesaplaDetayDtoList}
                                    key="id"
                                    keyExpr="id"
                                    showBorders={true}
                                    onToolbarPreparing={onToolbarPreparingHesapDetay}
                                >
                                     
                                    <Column type="buttons" caption={'İşlem'}
                                        buttons={[
                                            {
                                                hint: 'Düzenle', icon: 'edit',
                                                onClick: (e) => { editHesapDetay(e.row.data); }
                                            },
                                            {
                                                hint: 'Sil', icon: 'remove',
                                                onClick: (e) => { deleteHesapDetay(e.row.data); }
                                            }
                                        ]}
                                    />
 
                                    <Column dataField={'secili'} width={90} caption={'Seçim'}
                                       cellRender={editSecimeHesapDetayRender}/>


                                    <Column dataField={'baslangicTarihi'} width={90} caption={'Başlangıç Tarihi'} dataType="date" format="yyyy-MM-dd"  allowEditing={false}/>
                                    <Column dataField={'bitisTarihi'} width={90} caption={'Bitiş Tarihi'} dataType="date" format="yyyy-MM-dd"  allowEditing={false}/>
                                    <Column dataField={'detayTuru'} width={90} caption={'Türü'} allowEditing={false} >
                                        <Lookup dataSource={storeHesaplaDetayTuru} valueExpr="id" displayExpr="name" />
                                    </Column>

                                </DataGrid>

                            </Item>
                        </Item>
                        <Item itemType="group" colCount={5} colSpan={5}>
                            <Item itemType="group" caption={""} colCount={1} colSpan={1}>
                            </Item>

                            <Item itemType="group" caption={"Sonuç Bilgileri"} colCount={4} colSpan={4}>
                                <DataGrid
                                    width="100%"
                                    dataSource={sonucDtoList}
                                    key="id"
                                    //keyExpr="id"
                                    showBorders={true}
                                >
                                    <FilterRow visible={true} />
                                    <Export enabled={true} />
                                    <ColumnChooser enabled={true} title={"Kolon Seç"} emptyPanelText={"Buraya Sürükleyiniz..."} />
                                    <Scrolling columnRenderingMode="virtual" showScrollbar="always" />
                                    <Paging defaultPageSize={20} />
                                    <Pager showPageSizeSelector={true} allowedPageSizes={[10, 20, 30, 40, 60, 100, 200, 500, 1000]} showInfo={true} visible={true} />

                                    <Column type="buttons" caption={'İşlem'}
                                        buttons={[
                                            {
                                                hint: 'Görüntüle', icon: 'find',
                                                onClick: (e) => { goruntule(e.row.data); }
                                            }
                                        ]}
                                    />
                                    <Column dataField={'toplamGun'} width={90} caption={'Gün'} />
                                    <Column dataField={'hesapTuru'} width={90} caption={'HesapTuru'} visible={false} />
                                    <Column dataField={'hesapTarihi'} width={90} caption={'HesapTarihi'} dataType="date" format={"yyyy-MM-dd"} visible={false} />
                                    <Column dataField={'bakmaklaYukumluOlduguEsCocuk'} width={90} caption={'BYO'} visible={false} />
                                    <Column dataField={'toplamAMaasTutari'} width={90} caption={'Rat-a Maaş'} format={"#,##0.00"} />
                                    <Column dataField={'toplamBMaasTutari'} width={90} caption={'Rat-b Maaş'} format={"#,##0.00"} />
                                    <Column dataField={'toplamGun'} width={90} caption={'Toplam Gün'} format={"#,##0"} />
                                    <Column dataField={'ilaveGun'} width={90} caption={'İlave Gün'} format={"#,##0"} />
                                    <Column dataField={'oran'} width={90} caption={'Oran'} format={"#,##0.00"} />
                                    <Column dataField={'aMaasOranGunKatsayi'} width={90} caption={'Maaş Oran Katsayı'} format={"#,##0.00"} />
                                    <Column dataField={'maliyetTutari'} width={90} caption={'Maliyet'} format={"#,##0.00"} />
                                    <Column dataField={'amortiSuresi'} width={90} caption={'Amorti Süresi(Ay)'} format={"#,##0"} />
                                    <Column dataField={'aMaasFark'} width={90} caption={'Rat-a Maaş Fark'} format={"#,##0.00"} />
                                    <Column dataField={'bMaasFark'} width={90} caption={'Rat-b Maaş Fark'} format={"#,##0.00"} />
                                    <Column dataField={'bosColumn'} width={150} caption={''} dataType="string" visible={true} />
                                </DataGrid>


                            </Item>
                        </Item>
                    </Tab>

                </TabbedItem>
            </Form>

            <PopupForm
                visible={detayDataPopup.popupState}
                onHiding={hideDetayDataPopup}
                dragEnabled={false}
                closeOnOutsideClick={false}
                //showTitle={true}
                title="   Kullanıcı Detay Bilgi"
                width={1500}
                height={700}
            >
                <div>
                    {detayDataPopup.popupState ? <HesapForm data={detayDataPopup.data} hide={hideDetayDataPopup} /> : null}
                </div>
            </PopupForm>

            <PopupForm
                visible={hesapDuzenleDataPopup.popupState}
                onHiding={hideHesapDuzenleDataPopup}
                dragEnabled={false}
                closeOnOutsideClick={false}
                //showTitle={true}
                title="   Kullanıcı Detay Bilgi"
                width={350}
                height={285}
            >
                <div>
                    {hesapDuzenleDataPopup.popupState ? <HesapDetayDuzenleForm data={hesapDuzenleDataPopup.data} hide={hideHesapDuzenleDataPopup} /> : null}
                    <Button
                        width={1000}
                        text="Kapat"
                        type="danger"
                        stylingMode="contained"
                        onClick={hideHesapDuzenleDataPopup}
                    />
                </div>
            </PopupForm>

        </div>
    )
}

export default KullaniciHesap;
